export const izjava_smjestaj= {
    templateId: 238.1,
    category: 4,
    templateTitle: 'Troškovi smještaja radnika - Izjava radnika (zaposlenog kod dva ili više poslodavaca) o isplaćenim troškovima smještaja kod drugog/drugih poslodavaca',
    templateDescription: `<p>Radnik kojemu se isplaćuje trošak smještaja isplaćuje radniku, a zaposlen je istovremeno kod dva ili više poslodavaca, dužan je prije isplate dužan dostaviti poslodavcu izjavu o isplatama po navedenoj osnovi kod drugih poslodavaca.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    
    <p>Troškovi smještaja radnika nastali za vrijeme radnog odnosa kod poslodavaca mogu biti neoporezivo podmireni radniku, pri čemu se neoporezivi primitak priznaje za mjesec u kojem je usluga smještaja obavljena.</p>
    <p>Trošak smještaja radnika može biti podmiren:</p>
    <li>na način da poslodavac  s trećima ugovori pružanje usluga smještaja za radnika, ili </li>
    <li>organizacijom smještaja radnika kod samog poslodavca, ili</li>
    <li><strong>na način da radnik sam sklopi ugovor o najmu s pružateljem usluge ili nađe smještaj,  pri čemu se radniku isplaćuje naknada troškova smještaja na račun radnika, a o čemu poslodavac donosi odluku o isplati naknade koju možete pogledati <a class="local-link" href="/contract?template=238">ovdje</a>.</strong></li>
    <br>
    <p>Zadnje spomenuti način reguliranja troškova smještaja predstavlja osnovu za davanje izjave radnika koja se razmatra ovim tekstom i čiji primjer se daje u nastavku.</p>
    <p><strong>Ako se trošak smještaja isplaćuje radniku koji je zaposlen istovremeno kod dva ili više poslodavaca, radnik je dužan prije isplate dostaviti izjavu da su navedeni primici već isplaćeni za isto razdoblje, te se neoporezivo može isplatiti samo iznos do visine stvarnih izdataka.</strong></p>
    <p>U tom smislu je i izrađen primjerak izjave koji se nalazi u nastavku. </p>
    <p>Kako bi izjava bila aktualna s obzirom na trenutne okolnosti i možebitne isplate naknade od drugih poslodavaca radnika, predlaže se da radnik svakomjesečno izjavljuje poslodavcu koji isplaćuje naknadu troškova smještaj, je li ili nije ostvario pravo na naknadu troškova smještaja kod drugog poslodavca.</p>
    <p><strong>Također, važno je napomenuti da ukoliko radnik više nema izdataka za smještaj, obavezan je o istom obavijestiti poslodavca, a primjerak navedene obavijesti možete pogledati <a class="local-link" href="/contract?template=238.2">ovdje</a>.</strong></p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
      inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
      
    headline: "upućuje sljedeću",
    title: "IZJAVU",
  
    noArticleNumbers: true,
  
    articles: [
    {
      title: "",
      dummy: "true",
      mandatory: true,
      statements: [
      {
        type: "input",
        mandatory: true,
        editable: false,
        parts: [
          { type: "text", content: "kojom ja, gore navedeni, s danom davanje ove Izjave, izjavljujem Poslodavcu" },
          { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
          { type: "text", content: "," },
          { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
          { type: "text", content: ", OIB:" },
          { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
          { type: "text", content: "sljedeće:" },
        ],
        value:"",
      }]
    },
    {
      title: '',
      mandatory: false,
      dummy: true, 
      statements: [
          {
              type: 'choice',
              mandatory: true,
              choices: [
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, kod drugog/drugih poslodavaca, nisam primio nikakve naknade troškova smještaja." },
                      ]
                    },
                     {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, za sljedeće mjesece" },
                        { type: "textarea",  required: true, placeholder: "Unesite mjesece u kojima je ostvarena naknada." },
                        { type: "text", content: ", od drugog/drugih poslodavaca sam primio dio naknade ukupnih troškova smještaja u iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: " kn mjesečno, dok je puni mjesečni iznos troškova smještaja " },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                      ]
                  },
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, za sljedeće mjesece" },
                        { type: "textarea",  required: true, placeholder: "Unesite mjesece u kojima je ostvarena naknada." },
                        { type: "text", content: "od drugog/drugih poslodavaca, sam primio isplate troškove smještaja u punom iznosu stvarnih izdataka. " },

                      ]
}],
value: '',
}
]
},
{
  title: '',
  mandatory: true,
  dummy: true, 
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Osim prethodno navedenog, tijekom prethodno naznačenog razdoblja nisam ostvario nikakve druge primitke po osnovi naknade troškova smještaja, od bilo kojeg poslodavca.',
          value: '',
      }],
},
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures   
      statements: [],
    },
    {
      static: true,
      mandatory: true,
      editable: true,
      type: 4, 
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Poslodavac svojim potpisom potvrđuje primitak Izjave dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
          },
        ],
      },
  ],
  };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/238.1._izjava_smjestaj.ts